import { ClientType, Connector } from '@domain/connection/models/Connector';
import { Connection } from '@domain/connection/models/Connection';
import { ConnectorDTO, ConnectionDTO } from '../dto/MarketplaceDTOs';

export class ConnectionMapper {
    static toModel(dto: ConnectorDTO): Connector {
        return {
            type: dto.type as ClientType,
            image: dto.image,
        };
    }

    static toConnectionModel(dto: ConnectionDTO): Connection {
        return {
            id: dto.id,
            name: dto.name,
            companyId: dto.companyId,
            authorized: dto.authorized ?? true,
            active: dto.active ?? true,
            connector: ConnectionMapper.toModel(dto.connector)
        };
    }
}